import { createFileRoute } from '@tanstack/react-router'
import { benchmarkRun } from '@/lib/queries/benchmark-runs'
import { BenchmarkPage, BenchmarkProvider } from '@/features/admin'

export const Route = createFileRoute('/_authenticated/admin/benchmarks')({
  loader: ({ context }) => {
    context.queryClient.query({
      ...benchmarkRun.findSessionList(),
      staleTime: 'static',
    })
  },
  component: BenchmarksPage,
})

function BenchmarksPage() {
  return (
    <BenchmarkProvider>
      <BenchmarkPage />
    </BenchmarkProvider>
  )
}
